import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SiteFiltersType} from "../../types/site-filters.type";


export class PackagesIndicatorComponent implements IController {

  packages: any;
  maxDisplay: number;
  canFilterByValues: boolean;
  onFilterByType: Function;

  public viewPackages: any;
  public extraPackages: any;
  public sitePackageItemsMap: any;
  public isShowFilterByButton: boolean;
  public packageTypes: string[];
  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;


  constructor(private splitService) {
  }

  $onInit() {
    this.sitePackageItemsMap = this.splitService.getSitePackageItemsMap();

    this._initPackages(angular.copy(this.packages));
  }

  $onChanges(changes) {
    if (changes.packages && !changes.packages.isFirstChange()) {
      this._initPackages(this.packages);
    }
  };

  private _initPackages(packages) {

    if (!this.packages) return;

    this.packageTypes = this.packages.map(p => p.type || p.size);
    this.viewPackages = [];

    if (_.get(packages, 'length')) {

      this.viewPackages = this.maxDisplay ? _.filter(packages, (item, index: number) => {
        return index < this.maxDisplay;
      }) : packages;

      this.extraPackages = packages.slice(this.maxDisplay);

    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component('packagesIndicator', {
    bindings: {
      packages: '<',
      maxDisplay: '<?',
      canFilterByValues: '<?',
      onFilterByType: '&'
    },
    template: require('./packages-indicator.html').default,
    controller: PackagesIndicatorComponent
  });
